import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Conversation from './Conversation';
import PropertiesFilteringForm from './PropertiesFilteringForm';
import { useParams } from 'react-router-dom';

const TicketsPreview = ({}) => {

  const params=useParams();
  const {id,userId}=params;

const [ticketUserId,setTicketUserId]=useState();
  const setUserIdHandler=(userId)=>{
setTicketUserId(userId);
  }



  const _userData=JSON.parse(localStorage.getItem('userData'));

  return (
    <>
  {/* {userData && userData.roleId===3 && <TiektPreview />}
  {userData && userData.roleId===2 && <TiektPreviewClient />} */}
  <Row className="g-3">
     
     <Col xxl={9} xl={9}>
      <Conversation ticketMasterId={id}  /> 
     </Col>
     <Col xxl={3} xl={3}>
       <Row className="g-3 position-sticky top-0">
         <Col md={6} xl={12}>
           <PropertiesFilteringForm ticketMasterId={id} setUserIdHandler={setUserIdHandler} />
         </Col>
   
         {/* <Col xs={12}>
         {_userData.roleId==3 && ticketUserId &&   <ContactInfo userId={ticketUserId} />}
         </Col> */}
       </Row>
     </Col>
   </Row>
    </>
  );
};

export default TicketsPreview;
